// extracted by css-extract-rspack-plugin
export default {"root":"MaLrn8ZsgtchVymS","dense":"ae6fV8Dqjxw99djs"};